$(document).ready(function () {

  var better_slide = new Swiper(".better_slide .swiper-container", {
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    loop: true,
    spaceBetween: 16,
    centeredSlides: true,
    observer: true,
    observeParents: true,
    loopAdditionalSlides: 3,
    loopedSlides: 3,
    slidesPerView: 1.2,
    watchSlidesProgress: true,
    preloadImages: false,
    lazy: false,
    navigation: {
      nextEl: '.better_slide .swiper-button-next',
      prevEl: '.better_slide .swiper-button-prev',
    },
    breakpoints: {
      580:  { slidesPerView: 3, },
      1200: { slidesPerView: 6, centeredSlides: false, loop: false },
    },
    on: {
      init: function () {
        loadVideoAtIndex(this, this.activeIndex - 1);
        loadVideoAtIndex(this, this.activeIndex);
        loadVideoAtIndex(this, this.activeIndex + 1);

        if (!isPC()) {
          playActiveSlideVideo(this);
        }

        bindHoverEvents();  // hover 이벤트 등록
      },
      slideChange: function () {
        loadVideoAtIndex(this, this.activeIndex);
        loadVideoAtIndex(this, this.activeIndex + 1);

        if (!isPC()) {
          playActiveSlideVideo(this);
        }
      },
    },
  });

  // PC 여부 판단 (1200px 기준)
  function isPC() {
    return window.innerWidth >= 1200;
  }

  // PC hover 이벤트 바인딩
  // 복제 슬라이드 포함 전체 슬라이드에 적용
  function bindHoverEvents() {
    const slides = document.querySelectorAll('.better_slide .swiper-slide');

    slides.forEach(function (slide) {
      const video = slide.querySelector('video');
      if (!video) return;

      slide.addEventListener('mouseenter', function () {
        if (!isPC()) return;
        const source = video.querySelector('source[data-src]');
        if (source && !source.getAttribute('src')) {
          source.setAttribute('src', source.dataset.src);
          video.load();
          video.addEventListener('loadeddata', function () {
            video.play().catch(function () {});
          }, { once: true });
        } else {
          video.play().catch(function () {});
        }
      });

      slide.addEventListener('mouseleave', function () {
        if (!isPC()) return;
        video.pause();
        video.currentTime = 0;
      });
    });
  }

  const lazyVideos = document.querySelectorAll(
    '.better_slide .swiper-slide:not(.swiper-slide-duplicate) video.lazy-video'
  );

  const videoObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;

      const video = entry.target;
      const source = video.querySelector('source[data-src]');

      if (source && !source.getAttribute('src')) {
        source.setAttribute('src', source.dataset.src);
        video.load();
      }

      videoObserver.unobserve(video);
    });
  }, {
    rootMargin: '200px',
  });

  lazyVideos.forEach(function (video) {
    videoObserver.observe(video);
  });

  function loadVideoAtIndex(swiper, index) {
    const slide = swiper.slides[index];
    if (!slide) return;
    const video = slide.querySelector('video.lazy-video');
    if (!video) return;
    const source = video.querySelector('source[data-src]');
    if (source && !source.getAttribute('src')) {
      source.setAttribute('src', source.dataset.src);
      video.load();
    }
  }

  function playActiveSlideVideo(swiper) {
    swiper.slides.forEach(function (slide) {
      const video = slide.querySelector('video');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    });

    const activeSlide = swiper.slides[swiper.activeIndex];
    const activeVideo = activeSlide ? activeSlide.querySelector('video') : null;
    if (activeVideo) {
      activeVideo.play().catch(function () {});
    }
  }

});